export default __webpack_public_path__ + "static/media/cedar.24ae360c.svg";